import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../_metronic/layout";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "./_redux/Actions";
import { Pagination } from "../../../_metronic/_partials/controls";
import * as columnFormatters from "../../components/column-formatters";
import * as UIHelpers from "../../components/UIHelpers";
import DeleteDialog from "../../components/DeleteDialog";
import FilterComponent from "../../components/FilterComponent";
import { Formik, Field } from "formik";
import DropdownReactSelect from "../../components/DropdownReactSelect";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import helperFunc from "../../../_metronic/_helpers/helperFunc";

export const initialFilter = {
  filter: {},
  q: "",
  sort: "desc", // asc||desc
  sortBy: "craetedAt",
  skip: UIHelpers.skip,
  limit: UIHelpers.limit,
  page: UIHelpers.page,
  company: "gj",
};

const ListComponent = (props) => {
  const dispatch = useDispatch();
  const suhbeader = useSubheader();
  const [filter, setFilter] = useState(initialFilter);
  const [count, setCount] = useState(0);
  const [isDeleteShow, setIsDeleteShow] = useState(false);
  const [deleteItemRow, setDeleteItemRow] = useState(undefined);
  const [searchApply, setSearchApply] = useState(false);
  const [
    contestForSelectedDropdownFilterData1,
    setContestForListDropdownFilterData1,
  ] = useState([]);
  const [
    contestForDropdownFilterData1,
    setContestForDropdownFilterData1,
  ] = useState([]);
  suhbeader.setTitle("Coupon Categories");
  suhbeader.setIsSearch(true);
  useEffect(() => {
    filter.q = suhbeader.searchText.q;
    setFilter(filter);
    setCount(count + 1);
  }, [suhbeader, suhbeader.searchText]);

  const newItem = () => {
    props.history.push("/coupon-categories/create");
  };
  const editItem = (id) => {
    props.history.push(`/coupon-categories/edit/${id}`);
  };
  const deleteItem = () => {
    const id = deleteItemRow && deleteItemRow._id;
    dispatch(actions.deleteItem(id)).then(() => {
      dispatch(actions.fetchList(filter));
      hideDeleteConfirm();
    });
  };
  const hideDeleteConfirm = () => {
    setIsDeleteShow(false);
    setDeleteItemRow(undefined);
  };
  const deleteItemConfirm = (row) => {
    setIsDeleteShow(true);
    setDeleteItemRow(row);
  };
  const getHandlerTableChange = (type, data) => {
    if (type === "pagination") {
      filter.limit = data.sizePerPage;
      filter.skip = Math.abs(
        data.page ? data.sizePerPage - data.page * data.sizePerPage : 0
      );
      filter.page = data.page || 1;
      setFilter(filter);
      setCount(count + 1);
      if (!listLoading) {
        dispatch(actions.fetchList(filter));
      }
    }
    if (type === "sort") {
      filter.sort = data.sortOrder;
      filter.sortBy = data.sortField;
      setFilter(filter);
      setCount(count + 1);
      if (!listLoading) {
        dispatch(actions.fetchList(filter));
      }
    }
  };
  const filterChange = (filterData) => {
    filter.q = filterData.q;
    filter.filter = filterData.filter;
    setFilter(filter);
    setCount(count + 1);
    if (!listLoading) {
      dispatch(actions.fetchList(filter));
    }
  };
  const statusChange = (data) => {
    if(contestForSelectedDropdownFilterData1?.code?.toLowerCase() === "gj"){
      let params = {};
      params._id = data._id;
      params.isActive = !data.isActive;
      params.company = data.company;
      dispatch(actions.updateStatus(params)).then((sucess) =>
        sucess ? dispatch(actions.fetchList(filter)) : null
      );
      return;
    }
    const params = { ...data };
    params.isActive = !params.isActive;
    dispatch(actions.updateItem(params)).then((sucess) =>
      sucess ? dispatch(actions.fetchList(filter)) : null
    );
  };
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "createdAt",
      text: "CreatedAt",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.DateColumnFormatter,
    },
    {
      dataField: "isActive",
      text: "IsActive",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: columnFormatters.StatusColumnFormatter,
      formatExtraData: {
        statusChange: helperFunc.isButtonAccess(
          "coupons.couponCategories.update"
        )
          ? statusChange
          : null,
      },
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        editItem: helperFunc.isButtonAccess("coupons.couponCategories.update")
          ? editItem
          : null,
        deleteItem: helperFunc.isButtonAccess("coupons.couponCategories.delete")
          ? deleteItemConfirm
          : null,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];
  const { currentState } = useSelector(
    (state) => ({ currentState: state.couponCategories }),
    shallowEqual
  );
  const {
    totalCount,
    entities,
    listLoading,
    companyDropdownList1,
  } = currentState;
  useEffect(() => {
    dispatch(actions.fetchCompanyDropdownList1());
  }, []);
  useEffect(() => {
    if (companyDropdownList1 && companyDropdownList1?.data) {
      // let temp = [{
      //   _id: 0,
      //   label: "All",
      //   value: "all",
      //   baseUrl: "all",
      // }];
      let temp = [];
      const userdata = JSON.parse(localStorage.getItem("userData"));
      const userCompany = userdata?.company || [];
      companyDropdownList1.data.forEach((element, i) => {
        // if (!helperFunc.isAdmin()) {
          if (userCompany.includes(element._id)) {
            temp.push({
              _id: i + 1,
              label: element.name,
              value: element._id,
              baseUrl: element.baseUrl,
              code: element.code,
              "data-tokens": element.name,
            });
          }
        // } else {
        //   temp.push({
        //     _id: i + 1,
        //     label: element.name,
        //     value: element._id,
        //     baseUrl: element.baseUrl,
        //     code: element.code,
        //     "data-tokens": element.name,
        //   });
        // }
      });
      setContestForDropdownFilterData1(temp);
    }
  }, [companyDropdownList1]);
  
  const applyFilter = async (values) => {
    if (
      contestForSelectedDropdownFilterData1 == null ||
      contestForSelectedDropdownFilterData1.length <= 0
    ) {
      // This block is executed if contestForSelectedDropdownFilterData is null or empty.
      NotificationManager.error("Please Select Company", "Error");
      return false;
    }

    setSearchApply(true);
    var tampFilter = { ...filter };
    console.log(
      "contestForSelectedDropdownFilterData1",
      contestForSelectedDropdownFilterData1
    );
    tampFilter.company = contestForSelectedDropdownFilterData1.code;
    if (values?.phoneEmail) {
      tampFilter.search = {
        userID: values.phoneEmail,
      };
    }
    let selectedFields = [];

    // Add the logic to update the selectedFields array with the selected fields

    setFilter(tampFilter);

    console.log("tampFilter", tampFilter);

    if (!listLoading) {
      // dispatch(actions.fetchStaffUsers(tampFilter));

      localStorage.setItem(
        "selectedCompanyy",
        contestForSelectedDropdownFilterData1.code
      );
      dispatch(actions.fetchList(tampFilter));
    }
  };
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: UIHelpers.sizePerPageList,
    sizePerPage: filter.limit,
    page: filter.page,
  };

  const createFormInputs = () => {
    return (
      <div
        className="report-filter-bLock border-0 row align-items-center"
        style={{ padding: "0px 0" }}
      >
        <Formik
          initialValues={{}}
          onSubmit={(values) => {
            console.log("val::22", values);
            applyFilter(values);
          }}
        >
          {({ handleSubmit, values }) => (
            <div className="col-lg-12 col-md-12 mt-4 mb-3">
              {/* <div className="row m-0 p-0"> */}
              <form
                onSubmit={handleSubmit}
                className="form form-filter w-100"
                autoComplete="off"
                style={{ marginTop: "10px" }}
              >
                <div className="form-group row m-0 align-items-center z-index: 10">
                  <div
                    className="col-lg-4 col-md-6 z-index: 10 !important pl-0"
                    // style={{ maxWidth: "345px" }}
                  >
                    <label>Select Company</label>
                    <DropdownReactSelect
                      placeholder={"Company"}
                      name={"Company"}
                      value={contestForSelectedDropdownFilterData1}
                      // isMulti={values.isShared == 'true' ? true : false}
                      isMulti={false}
                      isClearable={true}
                      isSearchable={true}
                      closeMenuOnSelect={true}
                      options={contestForDropdownFilterData1}
                      onChange={setContestForListDropdownFilterData1}
                    />
                  </div>
                  <div className="justify-content-end mx-2">
                    <button
                      type="submit"
                      className="btn btn-dark"
                      style={{ width: "130px", marginTop: "20px" }}
                      disabled={listLoading}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </form>
              {/* </div> */}
            </div>
          )}
        </Formik>
      </div>
    );
  };
  return (
    <>
      <DeleteDialog
        show={isDeleteShow}
        name={deleteItemRow && deleteItemRow.name}
        item={deleteItemRow}
        onDelete={deleteItem}
        onHide={hideDeleteConfirm}
      />
      <NotificationContainer />
      <Card>
        <NotificationContainer />
        <CardHeader title="Coupon Categories list">
          <CardHeaderToolbar>
            {helperFunc.isButtonAccess("coupons.couponCategories.add") && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={newItem}
              >
                New Coupon Category
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        {createFormInputs()}
        {searchApply === true ? ( // searchApply === true
          entities?.length == 0 && listLoading === false ? (
            UIHelpers.dataTableNoData()
          ) : (
            <CardBody>
              <FilterComponent filterChange={filterChange} />
              <PaginationProvider
                pagination={paginationFactory(paginationOptions)}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return (
                    <Pagination
                      isLoading={listLoading}
                      paginationProps={paginationProps}
                    >
                      <BootstrapTable
                        wrapperClasses="table-responsive"
                        bordered={false}
                        classes="table table-head-custom table-vertical-center overflow-hidden"
                        bootstrap4
                        remote
                        keyField="_id"
                        data={entities ? entities : []}
                        columns={columns}
                        onTableChange={getHandlerTableChange}
                        {...props}
                        {...paginationTableProps}
                      >
                        <PleaseWaitMessage entities={entities} />
                        <NoRecordsFoundMessage entities={entities} />
                      </BootstrapTable>
                    </Pagination>
                  );
                }}
              </PaginationProvider>
            </CardBody>
          )
        ) : (
          // <h4 className="text-center">Please select search</h4>
          ""
        )}
      </Card>
    </>
  );
};
export default ListComponent;
